import React, { ReactNode, useState } from 'react';
import { BoxStyleProps } from '../Box';
import Popover from '../Popover';
import { PopoverPlacement } from '../Popover/Popover';

import styles from './Dropdown.module.css';
import DropdownButton from './DropdownButton';

interface DropdownProps extends BoxStyleProps {
  label: string;
  placement?: PopoverPlacement;
  children: ReactNode;
  className?: string;
}

export default function Dropdown({
  label,
  placement,
  children,
  className,
  ...otherProps
}: DropdownProps) {
  const [open, setOpen] = useState(false);

  return (
    <Popover
      open={open}
      placement={placement}
      className={className}
      onRequestClose={() => setOpen(false)}
      renderTrigger={(props) => (
        <DropdownButton
          {...props}
          text={label}
          onClick={() => setOpen(!open)}
          open={open}
        />
      )}
      {...otherProps}
    >
      <div className={styles['wrapper']}>{children}</div>
    </Popover>
  );
}
